import { makeStyles } from "@material-ui/core/styles";
import theme from "../../providers/theme-service";

export function useContentFormStyles() {
  const useStyles = makeStyles(() => ({
    root: {
      padding: 16,
      width: "100%",
    },
    label: {
      paddingBottom: 24,
      fontSize: theme.typography.pxToRem(24),
      fontWeight: 400,
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
